import main from "../assets/css/main.module.css";
import MainIntroduce from "./level2/MainIntroduce";
import MainMy from "./level2/MainMy";
import MainProject from "./level2/MainProject";
import MainSkill from "./level2/MainSkill";
import Header from "./level3/Header";
import { StatusProvider } from "./store/status-context";

export default function MainVer1() {
  return (
    <StatusProvider>
      <main className={main.main}>
        <Header />
        <MainIntroduce />
        <MainMy />
        <MainSkill />
        <MainProject />
      </main>
    </StatusProvider>
  );
}
